export const bytesToKb = (bytes: number): string => {
  const kb = bytes / 1024

  if (Math.floor(kb) === 0) {
    return `${bytes} bytes`
  }

  return `${kb.toFixed(2)} KB`
}
